import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Namespace } from 'enums-lib';
import { jwtDecode } from 'jwt-decode';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Identity } from 'storage-service-lib';
import { environment } from '../../../environments/environment';
import { VerifyLoginOtpResponse } from '../../components/login/login.service';
import { AbstractAuthService } from './abstract.auth.service';

@Injectable({ providedIn: 'root' })
export class BullhornAuthService extends AbstractAuthService {
  constructor(private http: HttpClient) {
    super();
  }

  override signIn(tenantName: string, options?: { env?: string }): Observable<any> {
    const callbackUrl = this.getRedirectUri();
    const requestAuthenticationHostUrl = `${environment.kpHost}/auth/bullhorn/host?targetCallback=${callbackUrl}`;
    return this.http.get(requestAuthenticationHostUrl, { responseType: 'text' }).pipe(
      map((authHostUrl) => {
        let launchUrl = `${environment.uiHost}/launchLogin.html`;
        launchUrl += '?redirectUrl=' + encodeURIComponent(authHostUrl);

        const successCallback = () => {};
        const buildIdentity = (jwt: string) => ({
          namespace: Namespace.bullhorn,
          tenant: jwtDecode<any>(jwt).corporationName,
          token: jwt,
        });

        return { launchUrl, buildIdentity, successCallback };
      })
    );
  }

  override signInWithOtp(decodedToken: any, otpObject: VerifyLoginOtpResponse, loginSuccess: EventEmitter<Identity>): void {
    loginSuccess.emit({
      namespace: Namespace.bullhorn,
      tenant: decodedToken.corporationName,
      token: otpObject.jwtToken,
    });
  }
}
